import React, { useEffect, useState } from "react";
import { euro, practiceApi } from "../../lib/practiceApi";

const CARDS = [["incaricato", "Incaricato"], ["da_fatturare", "Da fatturare"], ["fatturato", "Fatturato"],
  ["da_incassare", "Da incassare"], ["incassato", "Incassato"]];
const day = value => (value ? String(value).slice(0, 10).split("-").reverse().join("/") : "—");

export const ClientKpi = ({ clientId }) => {
  const [kpi, setKpi] = useState(null);
  useEffect(() => { practiceApi(`/billing/kpi/client/${clientId}`).then(setKpi).catch(() => {}); }, [clientId]);
  if (!kpi) return null;
  return <section className="practice-section" data-testid="client-kpi">
    <div className="practice-section-heading">
      <h2>Situazione economica</h2>
      <span>{kpi.fatture} fatture · ultima {day(kpi.ultima_fattura)} · ultimo pagamento {day(kpi.ultimo_pagamento)}</span>
    </div>
    <div className="overview-money">
      {CARDS.map(([key, label]) => <button key={key} type="button" data-testid={`client-kpi-${key}`}>
        <span>{label}</span><strong>{euro(kpi[key])}</strong>
      </button>)}
    </div>
  </section>;
};
